import { prop } from "ramda";
import { Maybe } from "ramda-fantasy";

import {
  type State,
  getMedidaSelecionada,
  getMedidasFiltradas,
  getModoExibicaoMedidaSelecionada,
  getGrupamentoMedidaSelecionado,
  getModoApp,
  getExibirConfiguracoesAvancadas,
} from "../../state";

import { GRUPAMENTO_MEDIDAS_QUALITATIVAS } from "../../model";

import { connect } from "react-redux";

const medidaId = prop("idConfiguracaoRelatorio");

export const connectMedidas = (mapDispatchToProps = {}) => {
  return connect(
    (state: State) => ({
      grupamentoMedidaSelecionado: getGrupamentoMedidaSelecionado(state),
      modoExibicaoSelecionado: getModoExibicaoMedidaSelecionada(state),
      exibirEdicao: Maybe(getMedidaSelecionada(state))
        .map(medida =>
          getMedidasFiltradas(state)
            .map(medidaId)
            .includes(medidaId(medida))
        )
        .getOrElse(true),
      modoApp: getModoApp(state),
      exibirConfiguracoesAvancadas: getExibirConfiguracoesAvancadas(state),
    }),
    mapDispatchToProps,
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      modoExibicaoSelecionado: (() => {
        switch (stateProps.grupamentoMedidaSelecionado) {
          case GRUPAMENTO_MEDIDAS_QUALITATIVAS:
            return "MEDIDA_QUALITATIVA";
          default:
            return stateProps.modoExibicaoSelecionado;
        }
      })(),
    })
  );
};
